import { observer } from "mobx-react-lite";

import { useEditCategoryModalState } from "./modal.state";
import { EditCategoryModalView } from "./modal.view";

export const EditCategoryModal = observer(() => {
  const state = useEditCategoryModalState();
  return <EditCategoryModalView state={state} />;
});
